import type { Translated, League } from '@uefadigital/panenka';
import { PkChip } from '@uefadigital/panenka-react';
import { memo, useCallback, useRef } from 'react';

import { useLeagues } from '../../hooks';

import GoogleTagManagerHelper from '@tracking/gtm-helper';

import * as styles from './styles.module.scss';

const LeaguesFilter = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { leagues, selectedLeague, setSelectedLeague } = useLeagues();

  const handleLeagueSelection = (league: Translated<League>) => () => {
    setSelectedLeague(league.id);
    GoogleTagManagerHelper.event(
      'Click',
      `Change league - ${league.shortName}`,
      'draw',
      { section_reference: 'draw', interaction: `Change league - ${league.shortName}` },
      'draw',
    );
  };

  const scrollToChip = useCallback(
    (leagueId: string) => (el: HTMLElement) => {
      if (el && leagueId === selectedLeague) {
        scrollRef.current?.scrollTo({ left: el.offsetLeft - 16, behavior: 'smooth' });
      }
    },
    [selectedLeague],
  );

  if (!leagues?.length) return null;

  return (
    <div ref={scrollRef} className={styles.scroll}>
      <div className={styles.leagues}>
        {leagues.map((league) => (
          <PkChip
            key={league.id}
            ref={scrollToChip(league.id)}
            className={styles.chip}
            selected={league.id === selectedLeague}
            onPkClick={handleLeagueSelection(league)}
          >
            {league.name}
          </PkChip>
        ))}
      </div>
    </div>
  );
};

export default memo(LeaguesFilter);
